'use client'
import React from 'react'
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton, EmailShareButton } from "react-share";

export default function BlogSocialShare({ blogfrontmatter }) {
    const currentblogurl = process.env.NEXT_PUBLIC_FRONTEND_URL + '/blog/' + blogfrontmatter.slug;


    const emailcontent = `
📖 Read the full article here:  
  `;

    return (
        <>
            <div className="flex items-center space-x-4 sm:flex-wrap">
                <h2>Share on</h2>
                <FacebookShareButton
                    url={currentblogurl}
                    hashtag={'#blog'}
                    // description={blogSummary as any}
                    // media={process.env.NEXT_PUBLIC_FRONTEND_URL + Image}
                    className="share-button"
                >
                    <span className="ms-2">
                        <i className="fa-brands fa-square-facebook text-3xl hover:text-gray-400"></i>
                    </span>
                </FacebookShareButton>

                <TwitterShareButton
                    url={currentblogurl}
                    title={blogfrontmatter.title}
                    hashtags={['#blog']}
                    related={[]}
                >
                    <span className="ms-2">
                        <i className="fa-brands fa-square-twitter text-3xl hover:text-gray-400"></i>
                    </span>
                </TwitterShareButton>

                <LinkedinShareButton
                    url={currentblogurl}
                    title={blogfrontmatter.title}
                    summary={blogfrontmatter.summary}
                    source={process.env.NEXT_PUBLIC_FRONTEND_URL} >
                    <span className="ms-2">
                        <i className="fa-brands fa-linkedin text-3xl hover:text-gray-400"></i>
                    </span>
                </LinkedinShareButton>

                <WhatsappShareButton
                    url={currentblogurl}
                    title={blogfrontmatter.title}
                    separator=" "
                >
                    <span className="ms-2">
                        <i className="fa-brands fa-square-whatsapp text-3xl hover:text-gray-400"></i>
                    </span>

                </WhatsappShareButton>

                <EmailShareButton
                    url={currentblogurl}
                    title={blogfrontmatter.title}
                    subject={`Check Out (${blogfrontmatter.title})`}
                    body={emailcontent}
                    separator=" "
                >
                    <span className="ms-2">
                        <i className="fa-solid fa-envelope text-3xl hover:text-gray-400"></i>
                    </span>
                </EmailShareButton>
            </div>

        </>
    )
}
